import type { DriftsmeldingDtoExtended, InformasjonsmeldingDto } from '@helsenorge/core-cms/info-eller-driftsmelding';
import type { Personverninnstilling } from '@helsenorge/framework-utils/hn-user';

/* Menu */

export enum MenuType {
  search = 'search',
  profile = 'profile',
  basic = 'basic',
}

/* Actions */

export enum ActionTypes {
  GetUserAction,
  GetHendelserAction,
  GetAntallUlesteForAlle,
  GetKunAntallUleste,
  GetMeldingerAction,
  GetHeaderFooterAction,
  GetTilesAction,
  GetAuthenticatedTilesAction,
  SetLoadingAction,
  SetIsAuthorizedAction,
  SetIsListenerReady,
  SetLanguage,
  SwitchUserAction,
  SetPersonvelgerRedirectUrlAction,
  error,
}

/**
 * Innlogget data
 */
export interface InnloggetDataResponse {
  InnloggetData: {
    RepresentertBruker: string;
    SistPaloggetDato: string;
    HarRepresentasjon: boolean;
    ErMellom12Og16: boolean;
    Scopes: string[];
    AktiveUtvalgtePersonverninnstillinger: Personverninnstilling[];
  };
}

/**
 * Driftspanel
 */

export type NotificationMessage = DriftsmeldingDtoExtended | InformasjonsmeldingDto;
